export enum ETypePieceJustificative {
	aucunePièce,
	attestationDeDroits,
	carteAssureSocial
}
